import { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import AppShell from "@/components/AppShell";
import api from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [state, setState] = useState("checking"); // checking | paid | failed
  const tries = useRef(0);

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setState("failed"); return; }
    let timer;
    const poll = async () => {
      tries.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setState("failed"); return; }
      } catch { /* keep trying */ }
      if (tries.current >= 15) { setState("failed"); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [params]);

  return (
    <AppShell>
      <div className="max-w-md mx-auto text-center py-16">
        {state === "checking" && (<>
          <Loader2 className="h-14 w-14 text-[#E25E3E] mx-auto mb-4 animate-spin" />
          <h1 className="font-heading font-black text-2xl text-[#1A1C1A] mb-2">Memverifikasi pembayaran…</h1>
          <p className="text-[#5C5F5C]">Mohon tunggu sebentar.</p>
        </>)}
        {state === "paid" && (<>
          <CheckCircle2 className="h-16 w-16 text-[#4A6B53] mx-auto mb-4" />
          <h1 className="font-heading font-black text-3xl text-[#1A1C1A] mb-2">Pembayaran Berhasil!</h1>
          <p className="text-[#5C5F5C] mb-6">TryOut premiummu sudah terbuka. Selamat mengerjakan!</p>
          <Link to="/tryout" data-testid="to-tryout-btn" className="px-6 py-3 rounded-full bg-[#E25E3E] text-white font-medium hover:bg-[#C94F31] transition-colors inline-block">Buka TryOut</Link>
        </>)}
        {state === "failed" && (<>
          <XCircle className="h-16 w-16 text-[#D9381E] mx-auto mb-4" />
          <h1 className="font-heading font-black text-2xl text-[#1A1C1A] mb-2">Pembayaran belum selesai</h1>
          <p className="text-[#5C5F5C] mb-6">Jika kamu sudah membayar, tunggu beberapa saat lalu cek kembali di halaman TryOut.</p>
          <Link to="/tryout" className="px-6 py-3 rounded-full border-2 border-[#1A1C1A] font-medium hover:bg-[#1A1C1A]/5 transition-colors inline-block">Kembali ke TryOut</Link>
        </>)}
      </div>
    </AppShell>
  );
}

export function PaymentCancel() {
  return (
    <AppShell>
      <div className="max-w-md mx-auto text-center py-16">
        <XCircle className="h-16 w-16 text-[#5C5F5C] mx-auto mb-4" />
        <h1 className="font-heading font-black text-2xl text-[#1A1C1A] mb-2">Pembayaran dibatalkan</h1>
        <p className="text-[#5C5F5C] mb-6">Tidak ada biaya yang dikenakan. Kamu bisa mencoba lagi kapan saja.</p>
        <Link to="/tryout" className="px-6 py-3 rounded-full bg-[#E25E3E] text-white font-medium hover:bg-[#C94F31] transition-colors inline-block">Kembali ke TryOut</Link>
      </div>
    </AppShell>
  );
}
